/* eslint-disable react-hooks/exhaustive-deps */
// import { Treemap } from '@ant-design/plots';
import { Gauge } from "@ant-design/plots";
import { Button, Image, ImageViewer, Popover, Swiper } from "antd-mobile";
import Certificate from "components/alert/Certificate";
import TreeCard from "components/Tree/TreeCard";
import transverterFn from "i18nData";
import { truncateString } from "modules/common";
import moment from "moment";
import DataCenterFailure from "pages/CarbonNeutralityDisclosure/Failure/DataCenterFailure";
import CollspseListStyle from "pages/DataCenter/card/CollspseListStyle";
import CollspseStyle from "pages/DataCenter/card/CollspseStyle";
import ColumnDom from "pages/DataCenter/chartList/ColumnDom";
import PieDom from "pages/DataCenter/chartList/PieDom";
import right_icon from "pages/DataCenter/images/right_icon.png";
import producttypeicon from "pages/HomePage/images/producttype.png";
import productxhicon from "pages/HomePage/images/productxh.png";
import productzlicon from "pages/HomePage/images/productzl.png";
import productzqicon from "pages/HomePage/images/productzq.png";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
// import Share from "components/alert/Share";
import { useHistory } from "react-router-dom";
import r, { api } from "../../modules/Request";
import "./../HomePage/HomePage.scss";
import blockchainicon from "./../HomePage/images/blockchain.png";
import icon2 from "./../HomePage/images/icon_2.png";
import icon3 from "./../HomePage/images/icon_3.png";
import icon4 from "./../HomePage/images/icon_4.png";
import icon5 from "./../HomePage/images/icon_5.png";
import icon6 from "./../HomePage/images/icon_6.png";
// import carbonjyicon from "./../HomePage/images/cabonjy.png";
import icon_right from "./../HomePage/images/icon_right.png";
import rightarrrowicon from "./../HomePage/images/rightarrow.png";
import yeziicon from "./../HomePage/images/yezi.png";
import arrowdropsicon from "./images/arrowdrops.png";
import arrowriseicon from "./images/arrowrise.png";
import descendicon from "./images/descend.png";
import riseicon from "./images/rise.png";
// import vsicon from './images/vs.png'
import vslineicon from "./images/vsline.png";
import "./index.scss";

const imgList = [icon2, icon3, icon4, icon5, icon6];
const zjcolors = ["#03BF8A", "#3192FF", "#FA9237", "#09B9B6", "#A185EB"];
const LCAemissionreduction = () => {
  const history = useHistory();
  const { id, type } = r.getQueryString();
  const language = useSelector((state) => state.language);
  const [visibleImg, setVisibleImg] = useState(false);
  const [technologyFlowImg, setTechnologyFlowImg] = useState(false);
  const imageViewerRef = useRef(0);
  const imageViewerRef1 = useRef(0);
  const swiperref = useRef(0);
  const swiperref1 = useRef(0);
  const [emissionimgList, setEmissionImgList] = useState([]);
  const [emissionimgListImg, setEmissionimgListImg] = useState(false);
  const [emissionimgListImg1, setEmissionimgListImg1] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataVal, setDataVal] = useState([]);
  const [txiddataVal, settxiddataVal] = useState();
  const [strAll, setStrAll] = useState({}); //写死的翻译数据
  const [resAll, setResAll] = useState([]); //接口返回的总数据
  const [visitH5Data, setVisitH5Data] = useState(false); //控制中英文
  const [emissionimgListIdx, setEmissionImgListIdx] = useState(0);

  // const jdimgLis = [jd1icon, jd2icon, jd3icon, jd4icon, jd5icon];
  const urlJoint = `id=${id + "1"}&type=${type}`;
  const urlJointAero = `id=${id + "0"}&type=${type}`;
  // 负数默认柱状图
  const isNullDom = (negativeFlag, thisVal, dom) => {
    console.log(negativeFlag);
    if (negativeFlag) {
      return <ColumnDom negativeFlag={negativeFlag} dataList={thisVal} />;
    } else {
      return dom;
    }
    console.log(negativeFlag, dom);
  };
  const config = {
    percent: Math.abs(resAll?.reductionRatio) / 100 || 0,
    radius: 0.48,
    range: {
      color: [`${resAll?.reductionCarbon > 0 ? "#FF5660" : "#03BF8A"}`, "#FFF"],
      width: 7,
    },
    startAngle: Math.PI - 0.5,
    endAngle: 2.14 * Math.PI,
    indicator: null,
    statistic: {
      title: {
        offsetY: -45,
        style: {
          fontSize: ".53rem",
          color: `${resAll?.reductionCarbon > 0 ? "#FF5660" : "#03BF8A"}`,
          fontWeight: "600",
        },
        // formatter: ({ percent }) => `${percent}<div className="percent">%</div>`,
        customHtml: (container, view, datum) => {
          console.log("datum", datum);
          const percent = Math.abs(resAll?.reductionRatio); // 计算百分比值
          return `<div style="font-size: 0.53rem; color:${
            resAll?.reductionCarbon > 0 ? "#FF5660" : "#03BF8A"
          }; font-weight: 600;">${percent}<span style="font-size: 0.24rem; color:${
            resAll?.reductionCarbon > 0 ? "#FF5660" : "#03BF8A"
          }; font-weight: 600; margin-left:0.05rem;">%</span></div>`; // 返回自定义的 HTML 内容
        },
      },
      content: {
        style: {
          lineHeight: ".4rem",
          fontSize: ".24rem",
          color: "#333333",
          marginTop: "-.4rem",
        },
        formatter: () => {
          return `<div>
            ${`减碳${
              resAll?.reductionCarbon > 0
                ? "上升"
                : resAll?.reductionCarbon < 0
                ? "下降"
                : ""
            }占比`}
          </div>`;
        },
      },
    },
    gaugeStyle: {
      lineCap: "round",
    },
  };
  const weChatSharing = (data) => {
    const url = window.location.href;
    // eslint-disable-next-line no-undef
    wx?.ready(function () {
      //需在用户可能点击分享按钮前就先调用
      // eslint-disable-next-line no-undef
      wx?.updateAppMessageShareData({
        title: data?.entName, // 分享标题
        // title: data?.data?.entName, // 分享标题
        desc: "低碳产品碳足迹披露", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        // imgUrl: data.boxPicList?.[0], // 分享图标
        imgUrl: data.boxPicList?.[0],
        success: function () {
          // 设置成功
        },
        error: (err) => {
          console.log(err);
        },
      });

      // eslint-disable-next-line no-undef
      wx?.updateTimelineShareData({
        title: data?.entName, // 分享标题
        // title: data?.data?.entName, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: data.boxPicList?.[0], // 分享图标
        success: function () {
          // 设置成功
        },
      });
    });
  };
  const getFillReviewFn = async () => {
    try {
      let res = await r.get(api.LCA_CARBON_FOOTQRCODE_REDUCTION + id);
      if (res.status.code === "00000") {
        let resData = res.data;
        console.log("resData", resData);

        document.title = res.data.zhProductDetail?.productName
          ? res.data.zhProductDetail?.productName + "碳减排"
          : "碳减排";
        setDataVal(resData);
        weChatSharing(res.data.zhProductDetail);
        /*  setDataVal(res.data);
         let stepListVal = res.data?.stepList.sort((a, b) => {
           return b.emissionValue - a.emissionValue;
         }); */

        // setStepList(stepListVal);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 区块链弹窗
  const getDetails = async (id) => {
    const result = await r.get(`${api.MODULARITY_USER_UPCHAIN_INFO}${id}`);
    if (result.status.code === "00000") {
      settxiddataVal(result?.data);
      setVisible(true);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    r.post(api.MODULAR_USER_VISIT_H5 + id);
    getFillReviewFn();
  }, []);
  useEffect(() => {
    setEmissionImgList(resAll?.certificateImg);
  }, [resAll]);
  useEffect(() => {
    console.log(language);
    setResAll(dataVal["zhProductDetail"]);
    setStrAll(transverterFn(true));
  }, [language, dataVal]);
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [resAll]);
  // useEffect(() => {

  // }, [resAll]);

  const Indicators = ({ total, currentIndex }) => {
    console.log("total", total);
    const [start, setStart] = useState(0);

    const handleClickIndicator = (index) => {
      setStart(index - 2 < 0 ? 0 : index - 2);
    };

    const renderIndicators = () => {
      const indicators = [];
      for (let i = 0; i < total; i++) {
        indicators.push(
          <span
            key={i}
            className={
              i === currentIndex ? "indicators-active" : "indicators-normal"
            }
            onClick={() => handleClickIndicator(i)}
          >
            0
          </span>
        );
      }
      return indicators;
    };

    return <div className="indicators">{renderIndicators()}</div>;
  };

  if (resAll?.h5DiscloseStatus == "0") {
    return <DataCenterFailure />;
  }
  return (
    <div className="detail_box emission_box">
      <ImageViewer
        image={resAll?.carbonDistributtionImg}
        visible={visibleImg}
        getContainer={() => document.body}
        onClose={() => {
          setVisibleImg(false);
        }}
      />
      <ImageViewer
        image={resAll?.technologyFlowImg}
        visible={technologyFlowImg}
        getContainer={() => document.body}
        onClose={() => {
          setTechnologyFlowImg(false);
        }}
      />

      <ImageViewer.Multi
        ref={imageViewerRef}
        images={emissionimgList}
        visible={emissionimgListImg}
        defaultIndex={0}
        onIndexChange={(i) => {
          swiperref.current.swipeTo(i);
        }}
        getContainer={() => document.body}
        onClose={() => {
          setEmissionimgListImg(false);
        }}
      />
      <ImageViewer.Multi
        ref={imageViewerRef1}
        images={resAll?.certificateImgSelf}
        visible={emissionimgListImg1}
        defaultIndex={0}
        onIndexChange={(i) => {
          swiperref1.current.swipeTo(i);
        }}
        getContainer={() => document.body}
        onClose={() => {
          setEmissionimgListImg1(false);
        }}
      />
      {/* <Share /> */}
      <Certificate visible={visible} setVisible={setVisible} list={dataVal} />
      <div className="app-content app-content-allbox">
        <div
          className="app-content-box white_box border_radius_hide"
          style={{ padding: ".1rem .32rem" }}
        >
          <div className="app-content-top">
            <img src={resAll?.entLogo} alt="" />
          </div>
        </div>

        <div className="content">
          <div class="top-header-box">
            <div className="detail_box_title" style={{ marginTop: ".32rem" }}>
              {resAll?.productName || "-"}
            </div>
            <div className="detail_box_tip">
              公司主体： {resAll?.entName || "-"}
            </div>
            {/* <div className="detail_box_tip">
            {strAll?.entName} {resAll?.entName || "-"}
          </div> */}
            <div className="card_bor card_bor_green">
              <div className="card_green_top">
                <div className="product-carbon-box">
                  <div className="carbon-box-left">
                    {/* <p>生命周期：{resAll?.bound}</p> */}
                    <p className="overflowbox">
                      {resAll?.carbonReductionDetailVO?.featureUnitImprove}
                      减碳幅度
                      {resAll?.reductionCarbon > 0
                        ? "上升"
                        : resAll?.reductionCarbon < 0
                        ? "下降"
                        : ""}
                    </p>
                    <p>{resAll?.carbonReductionDetailVO?.featureUnit}</p>
                  </div>
                </div>
                <div className="product-carbonvalue-box block_max">
                  <p
                    className={`value ${
                      resAll?.reductionCarbon > 0 ? "red" : "green"
                    }`}
                  >
                    <div className="img-box">
                      {resAll?.reductionCarbon > 0 ? (
                        <img src={riseicon} alt="" />
                      ) : (
                        <img src={descendicon} alt="" />
                      )}
                    </div>

                    {Math.abs(resAll?.reductionCarbon)}
                  </p>
                  <p className="unit">{resAll?.carbonReductionUnit}</p>
                  <div className="gauge_box">
                    <Gauge {...config} />
                  </div>
                </div>
              </div>
              <div className="product-carbonnumber-box-green">
                <div className="h32_box"></div>
                <div className="box-content top-box-content">
                  <div className="second-line-box">
                    <p>
                      基础产品{" "}
                      {resAll?.carbonReductionDetailVO?.productNameBase}
                    </p>
                    <img
                      onClick={() => {
                        // history.push('/home?' + urlJointAero)
                        history.push(
                          `/dataCenter?id=${id}&productType=1&type=${
                            type == "1" ? "" : "brief"
                          }`
                        );
                      }}
                      className="icon"
                      alt=""
                      src={icon_right}
                    />
                  </div>
                  <p className="overflowbox">
                    {resAll?.carbonReductionDetailVO?.featureUnitBase}
                  </p>

                  <p>
                    {resAll?.carbonReductionDetailVO?.carbonBase}
                    <span>{resAll?.carbonReductionDetailVO?.unitBase}</span>
                  </p>
                </div>
                <div className="image-box">
                  <img src={vslineicon} alt=""></img>
                </div>
                <div className="box-content bottom-box-content reduction-content">
                  <p>
                    减碳产品{" "}
                    {resAll?.carbonReductionDetailVO?.productNameImprove}
                  </p>
                  <p className="overflowbox">
                    {resAll?.carbonReductionDetailVO?.featureUnitImprove}
                  </p>
                  <p>
                    {resAll?.carbonReductionDetailVO?.carbonImprove}
                    <span>{resAll?.carbonReductionDetailVO?.unitImprove}</span>
                  </p>
                  {/* <img
                  onClick={() => {
                    history.push('/home?' + urlJoint)
                  }}
                  className="icon_right"
                  alt=""
                  src={icon_right}
                /> */}
                </div>
              </div>
            </div>
            <div className="white-item product-Blockchain-box">
              <p className="f48r bold">
                <img src={blockchainicon} alt=""></img>
                区块链存证
                {resAll?.certificateAddress && (
                  <span
                    className="detail_certificate_box"
                    onClick={() => {
                      getDetails(resAll?.certificateAddress.split("/")[6]);
                      // setVisible(true);
                      // window.open(resAll?.certificateAddress);
                    }}
                  >
                    查看证书
                    <img
                      alt=""
                      style={{
                        width: ".32rem",
                        height: ".32rem",
                        verticalAlign: "middle",
                        marginTop: "-.05rem",
                        marginRight: 0,
                      }}
                      className="right_icon"
                      src={right_icon}
                    />
                  </span>
                )}
                {/* <span className='detail_certificate_box' onClick={() => { setVisible(true) }}>查看证书 <RightOutlined style={{ fontWeight: 600 }} /></span> */}
              </p>
              <div className="hash-box">
                <div className="detail_cz_box">
                  <p className="">Hash: </p>
                  <p className="detail_certificate_address">
                    {resAll?.certificateContent &&
                      truncateString(resAll?.certificateContent)}
                  </p>
                </div>
                <div
                  className={
                    resAll?.certificateAddress
                      ? "jump-box"
                      : "jump-box btn_disabled"
                  }
                  onClick={() => {
                    // resAll?.certificateAddress && window.open(resAll?.certificateAddress)
                    if (resAll?.certificateAddress) {
                      getDetails(resAll?.certificateAddress.split("/")[6]);
                    }
                  }}
                >
                  <img src={rightarrrowicon} alt="" />
                </div>
              </div>
            </div>
          </div>

          <CollspseStyle>
            <h3 className="collspse_title">减排概览</h3>
            <div className="step_reduction_box">
              <div className="step_reduction_header">
                <div className="basics_title">{strAll?.BasicProduct}</div>
                <div className="improve_title">减碳产品</div>
                <div className="reduction_title">{strAll?.Reduction}</div>
              </div>
              <div style={{ marginTop: ".08rem" }}>
                {resAll?.carbonCompareStageRelVO?.map((item, idx) => {
                  return (
                    <>
                      <div className="step_reduction_body step_reduction_title">
                        <div
                          style={{ paddingTop: idx === 0 ? ".43rem" : "0" }}
                          className="basics_title"
                        >
                          <div className="ml-21r">
                            {item.baseStepName || "--"}
                          </div>
                        </div>
                        <div
                          style={{ paddingTop: idx === 0 ? ".43rem" : "0" }}
                          className="improve_title"
                        >
                          <div className="ml-21r">
                            {item.reduceStepName || "--"}
                          </div>
                        </div>
                        <div
                          style={{ paddingTop: idx === 0 ? ".43rem" : "0" }}
                          className="reduction_title"
                        >
                          {/* {item.carbonReduceAmplitude ? item.carbonReduceAmplitude : '--'} */}
                          <div
                            className={`emission_margin ${
                              Number(item.carbonReduceAmplitude) > 0
                                ? "child_red"
                                : Number(item.carbonReduceAmplitude) < 0
                                ? "child_green"
                                : "child_normal"
                            }`}
                          >
                            <div className="img-box">
                              {Number(item.carbonReduceAmplitude) > 0 ? (
                                <img src={arrowriseicon} alt="" />
                              ) : Number(item.carbonReduceAmplitude) < 0 ? (
                                <img src={arrowdropsicon} alt="" />
                              ) : (
                                <></>
                              )}
                            </div>
                            {item.carbonReduceAmplitude
                              ? Math.abs(item.carbonReduceAmplitude)
                              : "--"}
                          </div>
                        </div>
                      </div>
                      <div className="step_reduction_body step_reduction_val">
                        <div className="basics_title">
                          <div className="ml-21r">
                            {item.baseUnitCarbon || "--"}
                          </div>
                        </div>
                        <div className="improve_title">
                          <div className="ml-21r">
                            {item.reduceUnitCarbon || "--"}
                          </div>
                        </div>
                        <div className="reduction_title"></div>
                      </div>
                    </>
                  );
                })}
              </div>
              {/* <div className="step_reduction_tip">
                  {strAll?.functionalUnit}
                  {resAll?.featureUnit}/{resAll?.carbonUnit}
                </div> */}
              {type == "1" && (
                <Button
                  onClick={() => {
                    history.push(
                      "/lcaemissionDetail" +
                        window.location.search +
                        "&source=home&visitH5Data=" +
                        visitH5Data
                    );
                  }}
                  className="mt-53r  detail_btnstyle"
                  block
                  color="success"
                >
                  减排详情
                </Button>
              )}
            </div>
          </CollspseStyle>
          {resAll?.sceneAnalysis && (
            <CollspseStyle>
              <h3 className="collspse_title">
                {strAll?.CarbonReductionScenarioAnalysis}
              </h3>
              <div className="center_box">
                <div className="scenario_analysis_box">
                  <img className="yezi_icon" src={yeziicon} alt="" />
                  <div className="scenario_analysis">
                    {resAll?.sceneAnalysis}
                  </div>
                </div>
              </div>
            </CollspseStyle>
          )}
          {resAll?.certificateImg?.length > 0 && (
            <CollspseStyle>
              <h3 className="collspse_title">
                {strAll?.CarbonReductionCertificationEvaluationStart}
              </h3>
              <div className="estimate-box">
                <Swiper
                  ref={swiperref}
                  loop
                  // indicator={(total, current) => <Indicators total={total} currentIndex={current} />}
                  indicator={(total, current) => {
                    if (total > 1) {
                      return (
                        <div className="customIndicator">{`${
                          current + 1
                        } / ${total}`}</div>
                      );
                    }
                  }}
                  onIndexChange={(i) => {
                    imageViewerRef.current.swipeTo(i);
                    console.log(i, "onIndexChange1");
                  }}
                >
                  {emissionimgList?.map((item, index) => {
                    return (
                      <Swiper.Item key={index}>
                        <div className="swiper_box">
                          <Image
                            onClick={() => {
                              setEmissionimgListImg(true);
                            }}
                            height="7.13rem"
                            fit="contain"
                            src={item}
                          />
                        </div>
                      </Swiper.Item>
                    );
                  })}
                </Swiper>
                {resAll?.certificateLinkReduce && (
                  <div
                    className="more_btn"
                    onClick={() => {
                      window.open(resAll?.certificateLinkReduce);
                    }}
                  >
                    证书由 {resAll?.certificateOrgNameReduce} 颁发，查看详情
                    <span className="image-container">{">"}</span>
                  </div>
                )}
              </div>
            </CollspseStyle>
          )}

          <CollspseStyle>
            <h3 className="collspse_title">减碳产品碳足迹概览</h3>
            <div className="common_product_info_box">
              <div className="green_swiper_bor">
                {resAll?.boxPicList?.length == 1 ? (
                  <Image
                    width="8.72rem"
                    height="6.52rem"
                    fit="contain"
                    src={resAll?.boxPicList[0]}
                  />
                ) : (
                  <Swiper
                    autoplay
                    // trackOffset={10}
                    slideSize={80}
                    style={{
                      "--border-radius": "8px",
                    }}
                    loop
                    defaultIndex={0}
                    indicator={(total, current) => {
                      if (total > 1) {
                        return (
                          <div className="customIndicator">{`${
                            current + 1
                          } / ${total}`}</div>
                        );
                      }
                    }}
                  >
                    {resAll?.boxPicList?.map((item, index) => {
                      return (
                        <Swiper.Item key={index}>
                          <div className="swiper_box">
                            <Image height="6.52rem" fit="contain" src={item} />
                          </div>
                        </Swiper.Item>
                      );
                    })}
                  </Swiper>
                )}
              </div>
              <div
                className="white_box border_radius_hide"
                style={{ padding: ".43rem .32rem" }}
              >
                <div
                  className="detail_box_title"
                  style={{ fontSize: ".64rem" }}
                >
                  {resAll?.productName || "-"}
                </div>
                <div className="detail_box_tip">
                  {/* 公司主体：浙江耀阳新材料科技有限公司 */}
                  公司主体： {resAll?.entName || "-"}
                </div>
                {resAll?.labelContent && (
                  <p className="label_msg">
                    {resAll?.labelIcon && (
                      <div className="img-box">
                        <Image
                          className="label_msg_icon"
                          fit="contain"
                          src={resAll?.labelIcon}
                        />
                      </div>
                    )}
                    {resAll?.labelContent && (
                      <>
                        {resAll?.labelContent?.length > 21 ? (
                          <Popover
                            trigger="click"
                            placement="top"
                            content={resAll?.labelContent}
                          >
                            <p className="text-ellipsis label_msg_text">
                              {resAll?.labelContent}
                            </p>
                          </Popover>
                        ) : (
                          <p className="text-ellipsis label_msg_text">
                            {resAll?.labelContent}
                          </p>
                        )}
                      </>
                    )}
                  </p>
                )}
              </div>
              <div className="white-item product-info-box">
                <div className="product-info-box-item">
                  <img src={producttypeicon} alt="" />
                  <div className="item-right">
                    <p>产品分类</p>
                    <p>{resAll?.productCategoryCodeName || "--"}</p>
                  </div>
                </div>
                <div className="product-info-box-item">
                  <img src={productxhicon} alt="" />
                  <div className="item-right">
                    <p>产品型号</p>
                    <p>{resAll?.productModel || "--"}</p>
                  </div>
                </div>
                <div className="product-info-box-item">
                  <img src={productzqicon} alt="" />
                  <div className="item-right">
                    <p>生产周期</p>
                    <p>
                      {resAll?.fillTime?.[0] + " - " + resAll?.fillTime?.[1]}
                    </p>
                  </div>
                </div>
                {resAll?.productBrief && (
                  <div className="product-info-box-tip">
                    <p>产品简介</p>
                    <p>{resAll?.productBrief || ""}</p>
                  </div>
                )}
                {resAll?.productMoreFlag && (
                  <div
                    className="more-box"
                    onClick={() => {
                      history.push(
                        "/productDetail?id=" + id + "&productType=0"
                      );
                    }}
                  >
                    <p>查看更多</p>
                    <Image
                      className="right_icon"
                      fit="contain"
                      src={right_icon}
                    />
                  </div>
                )}
              </div>
            </div>
          </CollspseStyle>

          <CollspseStyle>
            <h3 className="collspse_title">产品碳足迹</h3>
            <div className="lca-data_center_box">
              <div className="card_gray_top">
                <div className="product-carbon-box">
                  <div className="carbon-box-left">
                    <p>产品碳足迹</p>
                    <p>{resAll?.featureUnit}</p>
                  </div>
                  <div className="product-carbonvalue-box">
                    <p className="value">{resAll?.carbon}</p>
                    <span>{resAll?.carbonUnit}</span>
                  </div>
                  <div className="bottom-box">
                    <p className="">
                      <span>系统边界：</span>
                      <span className="bound">{resAll?.bound}</span>
                    </p>
                    <p className="">
                      生产周期：
                      <span className="font-bold-500">
                        {(resAll?.fillTime?.[0] || "") +
                          " - " +
                          (resAll?.fillTime?.[1] || "")}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="common_card_box"
                style={{ paddingBottom: ".28rem" }}
              >
                <div className="product-bottom-box">
                  {resAll?.stageList?.map((item, idx) => {
                    return (
                      <div key={idx} className="product-bottom-box-item">
                        <div className="item-left">
                          <img src={item?.iconUrl} alt="" />
                          <p style={{ width: "auto" }}>{item?.name || "-"}</p>
                        </div>
                        <div
                          className={`item-right ${
                            Number(item.value) < 0 ? "item-right-red" : ""
                          }`}
                        >
                          <p>
                            {item.value?.toFixed(2) || "-"}{" "}
                            <span>{item.carbonUnit || "kg CO₂e"}</span>
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="charts_box">
                  {isNullDom(
                    resAll?.negativeFlag,
                    resAll?.stageList,
                    <PieDom dataList={resAll?.stageList} />
                  )}
                </div>
              </div>
              {/* <div className="product-Blockchain-box mt-43r">
                  <p className="f48r bold">
                    <img src={blockchainicon} alt="" />
                    区块链存证
                    {resAll?.certificateAddress && (
                      <span
                        className="detail_certificate_box"
                        onClick={() => {
                          // setVisible(true);
                          window.open(resAll?.certificateAddress)
                        }}
                      >
                        查看证书
                        <img
                          alt=""
                          style={{
                            width: '.32rem',
                            height: '.32rem',
                            verticalAlign: 'middle',
                            marginTop: '-.05rem',
                            marginRight: 0
                          }}
                          className="right_icon"
                          src={right_icon}
                        />
                      </span>
                    )}
                  </p>
                  <div className="hash-box">
                    <div className="detail_cz_box">
                      <p className="">
                        Hash：
                        {resAll?.certificateContent && truncateString(resAll?.certificateContent)}
                      </p>
                    </div>
                    <div
                      className={resAll?.certificateAddress ? 'jump-box' : 'jump-box btn_disabled'}
                      onClick={() => {
                        resAll?.certificateAddress && window.open(resAll?.certificateAddress)
                      }}
                    >
                      <img src={rightarrrowicon} alt="" />
                    </div>
                  </div>
                </div> */}
            </div>
          </CollspseStyle>

          {resAll?.processPics?.length > 0 && (
            <CollspseStyle>
              <h3 className="collspse_title">{strAll?.ProcessProcess}</h3>
              <div className="sprocessflow_swiper_bor">
                <p>生产工艺</p>
                {/* <Swiper> */}
                {resAll?.processPics?.map((item, index) => {
                  return (
                    <Swiper.Item key={index}>
                      <div className="swiper_box">
                        <Image fit="contain" src={item.url} />
                      </div>
                    </Swiper.Item>
                  );
                })}
                {/* </Swiper> */}
              </div>
            </CollspseStyle>
          )}
          {type == "1" && (
            <CollspseStyle>
              <h3 className="collspse_title">{strAll?.ProductDistribution}</h3>
              <div className="distribution-box">
                {resAll?.cumulativeAnalyseVO?.children?.map((item, idx) => {
                  return (
                    <div key={idx} className="tree-box">
                      <CollspseListStyle>
                        <div className="">
                          <h3
                            className="collspse_title collspse_detail_title"
                            // style={{ color: colorList[idx].color }}
                          >
                            <img
                              className="img_list_style"
                              alt=""
                              src={item?.iconUrl}
                            />
                            {item?.name}
                          </h3>
                          <div className="collspse_detail_title_value_box">
                            <p>
                              碳排放：
                              <span
                                className="collspse_detail_title_value"
                                // style={{ color: colorList[idx].color }}
                              >
                                {item?.summaryValueInt?.toFixed(2)}
                              </span>
                            </p>
                            <p className="ml-53r">
                              占比：
                              <span
                                className={`${
                                  Number(item?.proportion) < 0
                                    ? "collspse_detail_title_value_red"
                                    : "collspse_detail_title_value"
                                }`}
                                // style={{ color: colorList[idx].color }}
                              >
                                {item?.proportion}%
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="carbon_footprint_detail_card_box">
                          {item?.children?.length > 0 && (
                            <TreeCard data={item} />
                          )}
                        </div>
                      </CollspseListStyle>
                    </div>
                  );
                })}
              </div>
            </CollspseStyle>
          )}

          {resAll?.certificateImgSelf?.length > 0 && (
            <CollspseStyle>
              <h3 className="collspse_title">
                {strAll?.CarbonReductionCertificationEvaluation}
              </h3>
              <div
                className="green_swiper_bor emissionimgList_indicator"
                style={{ marginBottom: ".64rem" }}
              >
                <Swiper
                  ref={swiperref1}
                  style={{
                    "--border-radius": "8px",
                  }}
                  onIndexChange={(e) => {
                    console.log(e);
                    imageViewerRef1.current.swipeTo(e);
                  }}
                  loop
                  stuckAtBoundary={false}
                  indicator={(total, current) => {
                    if (total > 1) {
                      return (
                        <div className="customIndicator">{`${
                          current + 1
                        } / ${total}`}</div>
                      );
                    }
                  }}
                >
                  {resAll?.certificateImgSelf?.map((item, index) => {
                    return (
                      <Swiper.Item key={index}>
                        <div
                          key={index}
                          className="emissionimgList_img_box"
                          onClick={() => {
                            setEmissionimgListImg1(true);
                          }}
                        >
                          <Image height="7.13rem" fit="contain" src={item} />
                        </div>
                      </Swiper.Item>
                    );
                  })}
                </Swiper>

                {resAll?.certificateLink && (
                  <div
                    className="more_btn"
                    onClick={() => {
                      window.open(resAll?.certificateLink);
                    }}
                  >
                    证书由 {resAll?.certificateOrgName} 颁发，查看详情
                    <span className="image-container">{">"}</span>
                  </div>
                )}
              </div>
            </CollspseStyle>
          )}

          <CollspseStyle>
            <h3 className="collspse_title">碳足迹核算标准</h3>
            <div className="tempLcaRemark">
              <div className="bg-icon-box">
                <div className="card_box">
                  {resAll?.referenceReportList?.length > 0 && (
                    <div className="standard-box">
                      <p className="">报告参考标准</p>
                      <span className="referenceReportList">
                        {resAll?.referenceReportList?.map((item) => {
                          return <div className="mt-8">{item}</div>;
                        })}
                      </span>
                    </div>
                  )}

                  {resAll?.tempLcaRemark && (
                    <>
                      <p>系统边界说明</p>
                      <pre className="referenceReportList">
                        {resAll?.tempLcaRemark}
                      </pre>
                    </>
                  )}
                </div>
              </div>
            </div>
          </CollspseStyle>

          {/* <Button
            onClick={() => {
              history.push("/home?" + urlJoint);
            }}
            className="mt-18 detail_btnstyle"
            block
            color="success"
          >
            {strAll?.DetailsCarbonFootprint}
          </Button> */}
        </div>
        {(resAll?.entProfile || resAll?.footLogo) && (
          <div className="about_box">
            {resAll?.entProfile && (
              <div className="about_padding">
                <p className="about_title">关于我们</p>
                <p className="about_content">{resAll?.entProfile}</p>
              </div>
            )}

            {resAll?.footLogo && (
              <div className="data_center_logo">
                <Image src={resAll?.footLogo} />
              </div>
            )}
          </div>
        )}
        <Certificate
          visible={visible}
          setVisible={setVisible}
          list={{
            certificateContent: txiddataVal?.hashCode,
            certificateAddress: txiddataVal?.txid,
            blockHeight: txiddataVal?.blockNumber,
            certificateTime: moment(txiddataVal?.submitTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            certificateSubjects: txiddataVal?.entName,
            geoLocation: txiddataVal?.businessAddress,
            hashname: "存证哈希",
            addressname: "链上交易ID",
          }}
        />
      </div>
    </div>
  );
};

export default LCAemissionreduction;
